import { Component, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from "@angular/common";
import { Subject, of } from "rxjs";
import { takeUntil, tap, take, map, catchError } from "rxjs/operators";
import { MatDialog, MatDialogRef, MatDatepickerInputEvent, DateAdapter, MAT_DATE_FORMATS, MatIconRegistry } from '@angular/material';
import { TagsDialogComponent } from 'src/app/dialogs/tags-dialog/tags-dialog.component';
import { AllDocumentsDialogComponent } from 'src/app/dialogs/all-documents-dialog/all-documents-dialog.component';
import { UploadDocumentDialog } from 'src/app/dialogs/upload-document/upload-document-dialog.component';
import { API } from 'src/app/services/Api.service';
import { ErrorAction } from 'src/app/login/store/auth.actions';
import { GetTaskDetails, MoveTaskToNextState, UpdateTaskDetails, CancelTask, DeleteDocumentInTaskStartAction, GetActivityLog, UnlinkTasks, ViewTaskDetails, ApproveTaskTags, RejectTaskTags, EditDueDate, GetInactiveReplacedUsers, updatePacketDetails, createPacketDetails } from '../../home/tasks/store/tasks.actions';
import { ChangeOwnerDialogComponent } from '../../home/tasks/change-owner/change-owner.component';
import { NotificationModalComponent } from '../notification-modal/notification-modal.component';
import { AppState } from 'src/app/app.reducer';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../pipes/format-datepicker';
import { getComments, postComment } from '../../home/resources/_store/resources.actions';
import { AddViewersComponent } from '../../home/tasks/add-viewers/add-viewers.component';
import { CheckViewAccessGorDocStart, ClearViewAccess } from '../../home/user-messages/_store/messages.actions';
import { EditApproversEndorsersDialogComponent } from '../../home/tasks/edit-approvers-endorsers-dialog/edit-approvers-endorsers-dialog.component';
import { DocAccessPermissionComponent } from '../doc-access-permission/doc-access-permission.component';
import { EndorseVerifyOtpComponent } from '../task-details/endorse-verify-otp/endorse-verify-otp.component'
import { GetUserCapabilites, ClearAction } from '../../../../app/login/store/auth.actions';
import { SuggestTagsDialogComponent } from '../../../dialogs/suggest-tags-dialog/suggest-tags-dialog.component'
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from 'src/environments/environment';
import { CommentDialogue } from '../../home/tasks/comment-dialogue/comment-dialog.component';
import { MatTableDataSource } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Platform } from '@angular/cdk/platform';
import { TaskReopenDialogComponent } from '../../home/tasks/task-reopen-dialog/task-reopen-dialog.component'



@Component({
    selector: 'task-details',
    templateUrl: './task-details.component.html',
    styleUrls: ['./task-details.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: AppDateAdapter },
        { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }
    ]
})

export class TaskDetailsComponent implements OnDestroy {
    // date = new FormControl(moment());
    taskId: any;
    form: FormGroup;
    dueDateForm: FormGroup
    startDateForm: FormGroup;
    description: FormGroup
    taskDetail;
    status: any;
    subtasks$;
    linkedTasks$;
    isCreator;
    profilePic;
    subTasksHeadings = ['id', 'name', 'dueDate', 'status'];
    linkedTasksHeadings = ['id', 'name', 'dueDate', 'status', 'unlink'];
    userId;
    placeholderDate;
    stopper: Subject<void> = new Subject<void>();
    tags: any;
    linkedTasks: any;
    panelOpenState;
    isApproverEndoser;
    comments: Array<any> = [];
    commentPostPayload: object = {
        type: "task",
        doc_id: "",
        comment: ""
    };
    commentText: string = ''
    showRemoveButton: boolean = false;
    index;
    suggestedTagsToAdd: Array<any> = []
    suggestedTagsToRemove: Array<any> = []
    showSuggestedApproveTags: boolean = false;
    showRejectedApproveTags: boolean = false;

    activityLog: Array<any> = [];
    addApproverAnddEndorser: Boolean = false;
    stopper$: Subject<any> = new Subject();
    existingDocumentClicked: boolean = false;
    addNewDocumentClicked: boolean = false;
    documentData: { document: string; };
    viewmode: boolean = false;
    projectId: string;
    hasSuggestedTag: boolean = false;
    host = environment.host;

    tagsToAdd: MatTableDataSource<any>;
    tagsToRemove: MatTableDataSource<any>;

    EditDueDate: boolean = true
    dueDateInput: string = ''
    editDescription: boolean = false;
    editButtonClicked: boolean = false;

    @ViewChild('initialDueDatePicker', { static: false })
    dueDatePicker: ElementRef;
    minDate: any;
    isOwner;
    defaultPic: string;
    displayedColumns: string[] = ['Tag Name', 'Suggested By'];
    payload: object = { tagIdToAdd: '', tagIdToRemove: '', userId: '' }
    replacedUsers


    userTable: FormGroup;
    control: FormArray;
    touchedRows: any;

    constructor(
        private store: Store<AppState>,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        public location: Location,
        public route: Router,
        public ngxPermissionService: NgxPermissionsService,
        private dialog: MatDialog,
        iconRegistry: MatIconRegistry,
        sanitizer: DomSanitizer,
        private api: API) {
        this.form = this.fb.group({
            initialDueDate: [''],
            initialStartDate: ['']
        });

        this.touchedRows = [];
        this.userTable = this.fb.group({
            tableRows: this.fb.array([])
        });
        // this.addRow();
        this.dueDateForm = this.fb.group({
            dueDate: ['']
        });

        this.startDateForm = this.fb.group({
            startDate: ['']
        })

        this.description = this.fb.group({
            description: ['']
        })

        iconRegistry.addSvgIcon(
            'edit-icon',
            sanitizer.bypassSecurityTrustResourceUrl('assets/images/edit-icon.svg'));




    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params.mode == "view") {
                this.viewmode = true;
                this.projectId = params.projectId;
            }
        })
        this.store.dispatch(new ClearAction());
        this.store.select(state => state.auth).subscribe(auth => {
            this.profilePic = `${environment.host}/user/getImage/${auth.user.details._id}`;
        });
        this.store.select(state => state.tasks.taskDetail).pipe(takeUntil(this.stopper$)).subscribe((detail: any) => {
            if (Object.keys(detail).length) {
                console.log(detail, 'kkkkkkkkkkkkkkkkkkkkkkkkkkkk');
                this.taskDetail = detail;
                if (this.taskDetail.is_packet_available) {
                    if(this.taskDetail.packetList && this.taskDetail.packetList.length > 0){
                        this.setValueInform(this.taskDetail.packetList)
                    }
                   
                }
                this.minDate = this.getMinDate();
                this.placeholderDate = this.taskDetail['initialDueDate']
                // if (this.taskDetail['initialDueDate']) {
                this.form.get('initialDueDate').setValue(
                    this.placeholderDate ? new Date(this.placeholderDate) : null);
                // }
                // if (this.taskDetail.initialStartDate) {
                this.form.get('initialStartDate').setValue(
                    this.taskDetail.initialStartDate ? new Date(this.taskDetail.initialStartDate) : null);
                // }
                if (this.taskDetail['dueDate']) {
                    this.dueDateForm.get('dueDate').setValue(new Date(this.taskDetail['dueDate']))
                }
                if (this.taskDetail['startDate']) {
                    this.startDateForm.get('startDate').setValue(new Date(this.taskDetail['startDate']))
                }
                this.description.get('description').setValue(this.taskDetail.description || '')

                this.status = this.getStatus(this.taskDetail.status, "task");
                this.isCreator = this.userId === (this.taskDetail.owner || {})._id;
                this.isOwner = this.userId === (this.taskDetail.actualAssignee || {})._id;
                if ((this.isOwner || this.isCreator) && (!this.displayedColumns.includes('Actions')))
                    this.displayedColumns.push('Actions')
                if (!(this.isOwner || this.isCreator) && (this.displayedColumns.includes('Actions')))
                    this.displayedColumns.splice(this.displayedColumns.findIndex(element => element == 'Actions'), 1)
                this.isApproverOrEndorser();
                this.viewmode = !this.canAbleToEditTask(this.userId);
                console.log("this.viewMode", this.viewmode);
                if ((detail.suggestTagsToAdd || []).length) {
                    const suggestedTagsToAddTemp = detail.suggestTagsToAdd.filter(item => {
                        return item.tags.length > 0;
                    });
                    this.showSuggestedApproveTags = suggestedTagsToAddTemp.length > 0;
                } else {
                    this.showSuggestedApproveTags = false;
                }

                if ((detail.suggestTagsToRemove || []).length) {
                    const suggestedTagsToAddTemp = detail.suggestTagsToRemove.filter(item => item.tags.length > 0);
                    this.showRejectedApproveTags = suggestedTagsToAddTemp.length > 0;
                } else {
                    this.showRejectedApproveTags = false;
                }

                if (detail['suggestTagsToAdd']) {
                    this.suggestedTagsToAdd = []
                    detail['suggestTagsToAdd'].map(data => data.tags.map(tag => {
                        let temp = {}
                        temp['tag'] = tag.tag
                        temp['tagId'] = tag._id
                        temp['user'] = data.user
                        this.suggestedTagsToAdd.push(temp)
                    }))
                    this.tagsToAdd = new MatTableDataSource(this.suggestedTagsToAdd);
                }
                if (detail['suggestTagsToRemove']) {
                    this.suggestedTagsToRemove = []
                    detail['suggestTagsToRemove'].map(data => data.tags.map(tag => {
                        let temp = {}
                        temp['tag'] = tag.tag
                        temp['tagId'] = tag._id
                        temp['user'] = data.user
                        this.suggestedTagsToRemove.push(temp)
                    }))
                    this.tagsToRemove = new MatTableDataSource(this.suggestedTagsToRemove);
                }
            }

            // if (detail.suggestTagsToAdd) {
            //     detail.suggestTagsToAdd.forEach((element) => {
            //         if (element.userId == this.userId) { this.hasSuggestedTag = true; }
            //         if (element.tags.length > 0) {
            //             this.showSuggestedApproveTags = true;
            //         }
            //         else if (this.showSuggestedApproveTags == true) {
            //             this.showSuggestedApproveTags = true;
            //         }
            //         else {
            //             this.showSuggestedApproveTags = false;
            //         }
            //     });
            // }

            // if (detail.suggestTagsToRemove) {
            //     detail.suggestTagsToRemove.forEach((element) => {
            //         if (element.tags.length > 0) {
            //             this.showRejectedApproveTags = true;
            //         }
            //         else if (this.showRejectedApproveTags == true) {
            //             this.showRejectedApproveTags = true;
            //         } else {
            //             this.showRejectedApproveTags = false;
            //         }
            //     });
            // }
        });


        this.store.select(state => state.tasks.createPackectResponse).pipe(takeUntil(this.stopper$)).subscribe((detail: any) => {
            if (Object.keys(detail).length) {
                console.log(detail, 'kkkkkkkkkkkkkkkkkkkkkkkkkkkk');
                 this.store.dispatch(new ViewTaskDetails(this.projectId, this.taskId));
            }
        })

        this.store.select(state => state.tasks.updatePackectResponse).pipe(takeUntil(this.stopper$)).subscribe((detail: any) => {
            if (Object.keys(detail).length) {
                 this.store.dispatch(new ViewTaskDetails(this.projectId, this.taskId));
            }
        })

        this.store.select(state => state.tasks.viewTaskDetails).pipe(takeUntil(this.stopper$)).subscribe(detail => {
            this.taskDetail = detail;
            this.minDate = this.getMinDate();
            this.placeholderDate = this.taskDetail['initialDueDate']
            this.form.get('initialDueDate').setValue(new Date(this.placeholderDate));
            this.status = this.getStatus(this.taskDetail.status, "task");
            this.isCreator = this.userId === (this.taskDetail.owner || {})._id;
            this.isApproverOrEndorser();
        })

        this.activatedRoute.params.pipe(takeUntil(this.stopper$)).subscribe(params => {
            this.taskId = params.taskId;
            if (this.taskId) {
                if (this.projectId) {
                    this.store.dispatch(new ViewTaskDetails(this.projectId, this.taskId));
                } else {
                    this.store.dispatch(new GetTaskDetails(this.taskId));
                    this.store.dispatch(new GetInactiveReplacedUsers(this.taskId))
                    this.store.select(state => state.tasks.replacedUsers).subscribe(users => {
                        this.replacedUsers = users
                    })
                }
                if (Object.keys(this.ngxPermissionService.getPermissions()).includes('view-activity-log')) {
                    this.store.dispatch(new GetActivityLog(this.taskId));
                }
                this.store.dispatch(new getComments(this.taskId, 'task'));
            }
        });
        this.store.select(state => state.auth.user).pipe(
            take(1)
        ).subscribe(user => {
            if (user) {
                this.userId = user.details._id;
                // let loggedOwnerIndex =this.taskActionPermissionsIds.findIndex((id) => id === this.userId);
                // if(loggedOwnerIndex === -1) {
                // this.taskActionPermissionsIds.push(this.userId);

                // }
            }
        });

        // this.store.dispatch(new getComments(this.taskId))
        this.store.select(state => state.resources.comments)
            .subscribe(
                response => {
                    if (Object.keys(response).length) {
                        this.comments = response["comments"];
                        this.comments.map(comment => {
                            comment.displayPic = `${environment.host}/user/getImage/${comment.user._id}`
                        })
                    }
                },
                error => {
                    console.log(error);
                }
            );


        /* 
            CODE FOR ACTIVITY LOGS
        */
        this.store.dispatch(new GetUserCapabilites());
        this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
            if (response.length) {
                // let capabilities = response[0].capabilities;

                const capabilities = (response || []).reduce((acc, item) => {
                    return [...acc, ...item.capabilities];
                }, []);
                if (capabilities.includes("view-activity-log")) {
                    this.store.dispatch(new GetActivityLog(this.taskId));
                    this.store.select(state => state.tasks.activityLog).subscribe(response => {
                        this.activityLog = response;

                        this.activityLog.map(item => {
                            // invoke fn to build descriptive msg for every activity log
                            let logMsg = this.buildActivityLogMsg(item);
                            // push msg to existing object
                            item["logMsg"] = logMsg;
                            item["displayPic"] = `${environment.host}/user/getImage/${item.activityBy}`
                        });
                        this.activityLog = this.activityLog.filter(item => item.logMsg);
                    });
                }
            }
        })


        this.store.select(state => state.messages.viewAccessForDoc).pipe(takeUntil(this.stopper$)).subscribe((resp) => {
            const { noAccessDocuments, documents, ...others } = resp;
            // let users = Object.keys(others).some(key => others[key].length);
            if (resp && Object.keys(resp).length && (this.existingDocumentClicked || this.addNewDocumentClicked)) {
                console.log(resp);
                if (resp[0].users && resp[0].users.length > 1) {
                    const dialogRef = this.dialog.open(DocAccessPermissionComponent, {
                        width: '700px',
                        hasBackdrop: true,
                        panelClass: 'cmp-modal',
                        data: {
                            type: 'task',
                            detail: [...resp],
                            // yesButtonText: 'Give access & Update task',
                            // noButtonText: 'Update task without access'
                        }
                    });
                    dialogRef.afterClosed().subscribe((response) => {
                        if (response) {
                            this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, this.documentData));
                        }
                        this.existingDocumentClicked = false;
                        this.addNewDocumentClicked = false;
                    });
                } else {
                    this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, this.documentData));
                    this.existingDocumentClicked = false;
                    this.addNewDocumentClicked = false;
                }
            }

        })

    }

    ngAfterOnInit() {
        this.control = this.userTable.get('tableRows') as FormArray;
    }


    initiateForm(): FormGroup {
        return this.fb.group({
            _id: ['', Validators.required],
            proc_id: ['', Validators.required],
            packet_name: ['', [ Validators.required]],
            packet_budget: ['', [Validators.required]],
            isEditable: [true]
        });
    }

    initiateForm1(data) {
        return this.fb.group({
            _id: [data._id, Validators.required],
            proc_id: [data.seq_no, Validators.required],
            packet_name: [data.packet_name, [Validators.required]],
            packet_budget: [data.packet_budget, [Validators.required]],
            isEditable: [false]
        });
    }


    setValueInform(arr) {
        const control = this.userTable.get(
            "tableRows"
        ) as FormArray;
        control.clear();
        arr.forEach((element) => {
            control.push(this.initiateForm1(element));
        });
    }


    deleteRow(index: number) {
        const control = this.userTable.get('tableRows') as FormArray;
        control.removeAt(index);
    }

    editRow(group: FormGroup) {
        group.get('isEditable').setValue(true);
    }

    doneRow(group: FormGroup) {
        console.log(group);

        if(group.value._id == ''){
            if (group.value.packet_name && group.value.packet_budget ) {
                const payload = {
                    packet_name: group.value.packet_name,
                    packet_budget: group.value.packet_budget,
                }
                console.log(payload);
                
                this.store.dispatch(new createPacketDetails(this.taskId,this.projectId, payload));
                group.get('isEditable').setValue(false);
            } else {
                this.markFormGroupTouched(group)
                return;
            }
        }else{
            if (group.valid) {
                const payload = {
                    packet_name: group.value.packet_name,
                    packet_budget: group.value.packet_budget,
                }
                console.log(payload);
                
                this.store.dispatch(new updatePacketDetails(group.value._id, payload));
                group.get('isEditable').setValue(false);
            } else {
                this.markFormGroupTouched(group)
                return;
            }
        }






    }

    markFormGroupTouched(formGroup: FormGroup): void {
        (Object as any).values(formGroup.controls).forEach((control) => {
          control.markAsTouched();
          if (control.controls) {
            this.markFormGroupTouched(control);
          }
        });
      }

    get getFormControls() {
        const control = this.userTable.get('tableRows') as FormArray;
        return control;
    }

    addRow() {
        const control = this.userTable.get('tableRows') as FormArray;
        control.push(this.initiateForm());
    }
    /* 
        @author Pooja Gawas
        Builds customised descriptive messages for every activity log
        @param {Object} activityLog details of an activity log
        @returns {String} Message Customised msg for every activity log
    */
    buildActivityLogMsg(activityLog) {
        let fname = activityLog.activityBy.firstName;
        let lname = (activityLog.activityBy.middleName || '') + ' ' + activityLog.activityBy.lastName;
        // takes statusCode as input and returns status text. Needed for activity log of type "TASK_STATUS_UPDATED"
        // function getTaskStatus(statusCode) {
        //     switch (statusCode) {
        //         case 0:
        //             return "Create";
        //         case 1:
        //             return "To Do";
        //         case 2:
        //             return "In Progress";
        //         case 3:
        //             return "Pending Approval";
        //         case 4:
        //             return "Approved";
        //         case 5:
        //             return "Completed";
        //         case 6:
        //             return "Rejected";
        //         case 7:
        //             return "Request For Re-assignment";
        //         case 8:
        //             return "Cancelled";
        //         case 9:
        //             return "Pending Endorsement";
        //         case 10:
        //             return "Endorsed";
        //         default:
        //             return;
        //     }
        // }


        function getNamesFromIds(userIdsArr) {
            let namesArr: Array<any> = [];
            let namesStr: string;
            userIdsArr.map(item => {
                namesArr.push(`${item.firstName} ${item.lastName} `);
            });
            namesStr = namesArr.join();

            return namesStr ? namesStr : "none";
        }

        switch (activityLog.activityType) {
            case 'TASK_CREATED':
                return `${fname} ${lname} created this task`;

            case 'ASSIGNEE_CHANGED':
                return `${fname} ${lname} has changed the assignee for this task from ${activityLog.removedUserIds[0].firstName} ${activityLog.removedUserIds[0].lastName} to ${activityLog.addedUserIds[0].firstName} ${activityLog.addedUserIds[0].lastName}`;

            case 'APPROVED_BY_USER':
                return `${fname} ${lname} approved this task`;

            case 'ENDORSED_BY_USER':
                return `${fname} ${lname} endorsed this task`;

            case 'TASK_REOPENED':
                return `${fname} ${lname} reopened this task`;

            case 'TASK_REJECTED':
                return `${fname} ${lname} rejected this task`;

            case 'STEP_UPDATED':
                return `${fname} ${lname} has updated the step from ${activityLog.oldStep.name} to ${activityLog.updatedStep.name}`;

            case 'PILLAR_UPDATED':
                return `${fname} ${lname} has updated the pillar from ${activityLog.updatedPillar.name} to ${activityLog.updatedPillar.name}`;

            case 'APPROVERS_UPDATED':
                return `${fname} ${lname} has added ${getNamesFromIds(activityLog.addedUserIds)} and removed ${getNamesFromIds(activityLog.removedUserIds)} as approvers.`;

            case 'ENDORSERS_UPDATED':
                return `${fname} ${lname} has added ${getNamesFromIds(activityLog.addedUserIds)} and removed ${getNamesFromIds(activityLog.removedUserIds)} as endorsers.`;

            case 'SUPPORTERS_UPDATED':
                return `${fname} ${lname} has added ${getNamesFromIds(activityLog.addedUserIds)} and removed ${getNamesFromIds(activityLog.removedUserIds)} as supporters.`;

            case 'VIEWERS_UPDATED':
                return `${fname} ${lname} has added ${getNamesFromIds(activityLog.addedUserIds)} and removed ${getNamesFromIds(activityLog.removedUserIds)} as viewers.`;

            case 'TASK_STATUS_UPDATED':
                return `${fname} ${lname} has updated the task status from ${this.getStatus(activityLog.oldStatus, "activity_log")} to ${this.getStatus(activityLog.updatedStatus, "activity_log")}`

            case 'TASK_START_DATE_UPDATED':
                return `${fname} ${lname} has updated the start date from ${activityLog.previousStartDate} to ${activityLog.updatedStartDate}`;

            case 'TASK_DUE_DATE_UPDATED':
                return `${fname} ${lname} has updated the due date from ${activityLog.previousEndDate} to ${activityLog.updatedEndDate}`;

            case 'DOCUMENTS_ADDED':
                return `${fname} ${lname} added documents to this task.`;

            case 'SUBTASK_ADDED':
                return `${fname} ${lname} added subtask ${(activityLog.subTask || {}).name} to this task.`;

            case 'DOCUMENTS_REMOVED':
                return `${fname} ${lname} removed documents from this task`;

            case 'SUBTASK_REMOVED':
                return `${fname} ${lname} removed subtask ${(activityLog.subTask || {}).name} from this task.`;

            case 'NEW_TASK_LINKED':
                return `${fname} ${lname} linked ${(activityLog.subTask || {}).name} task to this task`;

            case 'LINKED_TASK_REMOVED':
                return `${fname} ${lname} removed linked task ${(activityLog.subTask || {}).name} from this task.`;

            case 'TAGS_UPDATED':
                return `${fname} ${lname} updated tags of this task.`;
            case 'NEW_RESPONSE':
                return activityLog.message;

            default:
                return;
        }
    }

    // addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    //   this.events.push(`${type}: ${event.value}`);
    // }

    initialDueDateChanged(event, type = '') {
        let obj = {};
        this.placeholderDate = `${event.value}`;
        if (type.includes('initialStartDate')) {
            obj['initialStartDate'] = new Date(this.placeholderDate);
        } else {
            obj['initialDueDate'] = new Date(this.placeholderDate);
        }
        // this.placeholderDate = `${event.value}`;
        // let obj = {
        //     "initialDueDate": new Date(this.placeholderDate)
        // }
        this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, obj));
        // this.store.dispatch(new EditTaskInProject(this.projectId, this.taskDetails._id, payload));
    }

    getMinDate() {
        const currentDate = new Date().getTime();
        const taskStartDate = this.taskDetail.initialStartDate || this.taskDetail.startDate;
        if (taskStartDate) {
            const taskStartDateTime = new Date(taskStartDate).getTime();
            return taskStartDateTime > currentDate ? new Date(taskStartDateTime) : new Date(currentDate);
        } else {
            return new Date(currentDate);
        }
    }

    getStatus(param, type) {
        if (typeof param == "undefined") {
            return;
        }

        let status_code;
        if (type == "activity_log") {
            status_code = param;
        }
        else {
            status_code = param.status
        }

        switch (status_code) {
            case 0:
                return "Create";
            case 1:
                return param.rejected ? ' Rejected ' : param.reopened ? 'Reopened' : 'To Do';
            case 2:
                return 'In Progress';
            case 3:
                return 'Pending Approval';
            case 4:
                return 'Approved';
            case 5:
                return 'Completed';
            case 6:
                return "Rejected";
            case 7:
                return 'Request For Re-assignment';
            case 8:
                return 'Cancelled';
            case 9:
                return 'Pending Endorsement';
            case 10:
                return 'Endorsed';
        }
    }



    ngOnDestroy() {
        this.stopper$.next();
        this.stopper$.complete();
        this.existingDocumentClicked = false;
        this.addNewDocumentClicked = false;
    }

    goToAddViewer() {
        const dialogRef = this.dialog.open(AddViewersComponent, {
            width: "60%",
            panelClass: "cmp-modal",
            data: {
                taskId: this.taskId,
                viewers: this.taskDetail.viewers
            }
        });
    }

    changeTaskState(action, boolean, status) {
        let payload = {};
        if (action === 'done') {
            if (boolean) {

                payload['submitForApproval'] = true;
            }

        } else if (action === 'approve') {
            payload['approved'] = true;
            action = 'done';
        } else if (action === 'endorse') {
            payload['endorsed'] = true;
            action = 'done';
        }

        if (status == 9) {
            // const dialogRef = this.dialog.open(EndorseVerifyOtpComponent, {
            //     width: '700px',
            //     hasBackdrop: true,
            //     panelClass: 'cmp-modal',
            //     data: {
            //         taskId: this.taskId
            //     }
            // });

            // dialogRef.afterClosed().subscribe((response) => {
            //     if (response) {
            const dialogRef = this.dialog.open(CommentDialogue, {
                width: '700px',
                hasBackdrop: true,
                panelClass: 'cmp-modal',
            });

            dialogRef.afterClosed().subscribe((response) => {
                if (response) {
                    // if (Object.keys(this.ngxPermissionService.getPermissions()).includes('document-comments')) {
                    payload['comment'] = response;
                    // }
                    this.store.dispatch(new MoveTaskToNextState(this.taskId, action, payload));
                }
            })
            //     }
            // })
        } else if (action === 'reopen') {
            if (this.replacedUsers.inactiveUserExists) {
                const dialogRef = this.dialog.open(TaskReopenDialogComponent, {
                    width: '700px',
                    hasBackdrop: true,
                    panelClass: 'cmp-modal',
                    data: {
                        taskId: this.taskId,
                        action: action
                    }
                });
            }
            else {
                const dialogRef = this.dialog.open(CommentDialogue, {
                    width: '700px',
                    hasBackdrop: true,
                    panelClass: 'cmp-modal',
                });

                dialogRef.afterClosed().subscribe((response) => {
                    if (response) {
                        // if (Object.keys(this.ngxPermissionService.getPermissions()).includes('document-comments')) {
                        payload['comment'] = response;
                        // }
                        this.store.dispatch(new MoveTaskToNextState(this.taskId, action, payload));
                    }
                })
            }


        } else if (status === 3) {
            const dialogRef = this.dialog.open(CommentDialogue, {
                width: '700px',
                hasBackdrop: true,
                panelClass: 'cmp-modal',
            });

            dialogRef.afterClosed().subscribe((response) => {
                if (response) {
                    // if (Object.keys(this.ngxPermissionService.getPermissions()).includes('document-comments')) {
                    payload['comment'] = response;
                    // }
                    this.store.dispatch(new MoveTaskToNextState(this.taskId, action, payload));
                }
            })
        }
        else {
            this.store.dispatch(new MoveTaskToNextState(this.taskId, action, payload));
        }
        // [create, assign, accept, reassign, done, unclaim, approve, reject, complete, reopen]
        // state gets changd here..

    }
    onClick(owner) {
        this.route.navigate(['..', 'create-task'], { queryParams: { owner: owner } });
    }

    goToSubTask(task) {
        this.route.navigate(['home', 'tasks', task._id]);
    }
    goToLinkedTask(task) {
        this.route.navigate(['home', 'tasks', task._id]);
    }

    editDueDatePicker() {
        // return (!this.taskDetail.isFutureTask && this.isCreator && (this.taskDetail.status !== 5 && this.taskDetail.status !== 8));
        return (this.isCreator && (this.taskDetail.status !== 5 && this.taskDetail.status !== 8));
    }

    compareDueDate(dueDt) {
        const dueDate = new Date(dueDt);
        const currentDate = new Date();
        return (dueDate > currentDate) ? 1 : (dueDate < currentDate) ? -1 : 0;
    }
    addTagsClicked() {
        const dialogRef = this.dialog.open(TagsDialogComponent, {
            hasBackdrop: true,
            width: "700px",
            // height: '300px',
            panelClass: 'task-detail-modal',
            data: {
                alertTitle: 'Add Tags',
                placeHolder: 'Add Tag (search with keywords)',
                selectedTags: [{ _id: '12345', tag: 'tag1' }, { _id: '1', tag: 'tag2' }, { _id: '2', tag: 'tag3' }],
                allDetails: this.taskDetail,
                type: 'tags',
                module: 'task'
            }

        })
        dialogRef.afterClosed().subscribe((response) => {
            if (response !== '') {
                this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { "tags": response }))

            }
        })

    }

    suggestTags() {
        const dialog = this.dialog.open(SuggestTagsDialogComponent, {
            width: "40%",
            hasBackdrop: true,
            panelClass: "task-detail-modal",
            data: {
                allDetails: this.taskDetail,
                type: "documentHub",
                alertTitle: "Suggest Tags",
                placeHolder: "Add Tag (search with key words)",
                taskTags: true
            }
        });

    }

    linkTasksClicked() {
        const dialogref = this.dialog.open(TagsDialogComponent, {
            hasBackdrop: true,
            width: '700px',
            // height: '300px',
            panelClass: 'task-detail-modal',
            data: {
                alertTitle: 'Link Task',
                placeHolder: 'Add Task (search by task id )',
                type: 'linkedTasks',
                allDetails: this.taskDetail,
            }
        })
        dialogref.afterClosed().subscribe((response) => {
            if (response !== '') {
                this.linkedTasks = (response || []).map((taskId) => taskId);
                this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { 'linkedTasks': this.linkedTasks }))
            }
        });
    }

    unlinkTask(element) {
        this.store.dispatch(new UnlinkTasks({ 'id': this.taskId, 'subTaskId': element._id }))
        this.store.dispatch(new GetTaskDetails(this.taskId));
    }
    isApproverOrEndorser() {
        const isApprover = (this.taskDetail.approvers || []).filter(appr => appr._id.includes(this.userId)).length > 0;
        const isEndorser = (this.taskDetail.endorsers || []).filter(end => end._id.includes(this.userId)).length > 0;
        const isViewers = (this.taskDetail.viewers || []).filter(view => view._id.includes(this.userId)).length > 0;
        this.isApproverEndoser = isApprover || isEndorser || isViewers;
    }
    // approverClicked() {
    //     const dialogref = this.dialog.open(TagsDialogComponent, {
    //         hasBackdrop: true,
    //         width: '700px',
    //         panelClass: 'task-detail-modal',
    //         data: {
    //             alertTitle: 'Edit Approvers',
    //             placeHolder: 'Add Approvers...',
    //             type: 'approvers',
    //             allDetails: this.taskDetail
    //         }
    //     })
    //     let approverIds = this.taskDetail.approvers.map(({ _id }) => _id)
    //     dialogref.afterClosed().subscribe((response) => {
    //         console.log(response, "response")
    //         if (response != '') {
    //             this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { 'approvers': [...response, ...approverIds] }))
    //         }
    //         this.existingDocumentClicked = false;
    //         this.addNewDocumentClicked = false;
    //     });

    // }

    openEditApproversDialog() {
        const dialogref = this.dialog.open(EditApproversEndorsersDialogComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'cmp-modal',
            data: {
                alertTitle: 'Edit Approvers',
                placeHolder: 'Add Approvers...',
                type: 'approvers',
                allDetails: this.taskDetail
            }
        })
        dialogref.afterClosed().subscribe((response) => {
            if (response === '') {
                return;
            }
            this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { 'approvers': [...response] }))
            this.existingDocumentClicked = false;
            this.addNewDocumentClicked = false;
        });

    }

    openEditEndorsersDialog() {
        const dialogref = this.dialog.open(EditApproversEndorsersDialogComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'cmp-modal',
            data: {
                alertTitle: 'Edit Endorsers',
                placeHolder: 'Add Endorsers...',
                type: 'endorsers',
                allDetails: this.taskDetail
            }
        })
        dialogref.afterClosed().subscribe((response) => {
            if (response !== '') {
                this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { 'endorsers': [...response] }))
            }
            this.existingDocumentClicked = false;
            this.addNewDocumentClicked = false;
        })
    }

    // endorserClicked() {
    //     const dialogref = this.dialog.open(TagsDialogComponent, {
    //         hasBackdrop: true,
    //         width: '700px',
    //         panelClass: 'task-detail-modal',
    //         data: {
    //             alertTitle: 'Edit endorsers',
    //             placeHolder: 'Add Endorsers...',
    //             type: 'endorsers',
    //             allDetails: this.taskDetail
    //         }
    //     })
    //     let endorserIds = this.taskDetail.endorsers.map(({ _id }) => _id)
    //     dialogref.afterClosed().subscribe((response) => {
    //         if (response != '') {
    //             this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { 'endorsers': [...response, ...endorserIds] }))
    //         }
    //         this.existingDocumentClicked = false;
    //         this.addNewDocumentClicked = false;
    //     });


    // }

    changeOwner() {

        const changeOwnerDialog = this.dialog.open(ChangeOwnerDialogComponent, {
            hasBackdrop: true,
            width: '700px',
            panelClass: 'task-detail-modal',
            data: {
                alertTitle: 'Edit endorsers',
                placeHolder: 'Add Endorsers...',
                type: 'endorsers',
                allDetails: this.taskDetail,
                userId: this.userId
            }
        });

        changeOwnerDialog.afterClosed().subscribe((response) => {
            if (response != undefined) {
                this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, { assignee: response._id }));

            }
        });
    }


    cancelTask(id) {
        const dialog = this.dialog.open(NotificationModalComponent, {
            width: '450px',
            hasBackdrop: true,
            panelClass: 'cmp-modal',
            data: {
                text: 'Are you sure you want to cancel the task?',

            }
        })
        dialog.afterClosed().subscribe((response) => {
            if (response != undefined) {
                if (response) {
                    this.store.dispatch(new CancelTask(id));
                }
            }
        })
    }
    addNewDocument() {
        const dialog = this.dialog.open(UploadDocumentDialog, {
            width: '70%',
            height: '85%',
            panelClass: 'compose-mailbox',
        })
        dialog.afterClosed().subscribe((data) => {
            if (data !== undefined && data && Object.keys(data).length) {
                let approverIds = this.taskDetail.approvers.map(({ _id }) => _id)
                let endorserIds = this.taskDetail.endorsers.map(({ _id }) => _id)
                let creatorId = this.taskDetail.owner._id;
                let ownerId = this.taskDetail.actualAssignee._id;
                let viewersId = this.taskDetail.viewers.map(({ _id }) => _id);
                let docIds = this.taskDetail.documents.map(({ _id }) => _id);
                let checkObj = {
                    userIds: Array.from(new Set([...approverIds, ...endorserIds, ...ownerId, ...creatorId, ...viewersId])),
                    docIds: [data._id],
                    unique: true
                }
                this.store.dispatch(new ClearViewAccess());
                this.store.dispatch(new CheckViewAccessGorDocStart(checkObj));
                let obj = {
                    document: data._id
                }
                this.documentData = obj
            }
        })
        this.addNewDocumentClicked = true;
    }
    addExistingDocument() {
        const docAttachments = this.taskDetail.documents.map(doc => doc._id);
        const dialog = this.dialog.open(AllDocumentsDialogComponent, {
            width: '90%',
            height: '85%',
            panelClass: 'compose-mailbox',
            data: {
                attachments: docAttachments,
            }
        })
        dialog.afterClosed().subscribe((data) => {
            if (data !== undefined && data && Object.keys(data).length) {
                let published: boolean = (data.status == 2) ? true : false;
                data._id = data._id ? data._id : data.id;
                let obj = {
                    document: data._id
                }
                this.documentData = obj;
                let approverIds = this.taskDetail.approvers.map(({ _id }) => _id)
                let endorserIds = this.taskDetail.endorsers.map(({ _id }) => _id)
                let creatorId = [this.taskDetail.owner._id];
                let viewersId = this.taskDetail.viewers.map(({ _id }) => _id);
                let ownerId = [this.taskDetail.actualAssignee._id];
                if (creatorId[0].length && ownerId[0].length) {

                    creatorId = (creatorId[0] === ownerId[0]) ? [] : creatorId;
                }
                let docIds = this.taskDetail.documents.map(({ _id }) => _id)
                let checkObj = {
                    userIds: Array.from(new Set([...approverIds, ...endorserIds, ...ownerId, ...creatorId, ...viewersId])),
                    docIds: [data._id],
                    unique: true
                }
                if (!published) {
                    this.store.dispatch(new CheckViewAccessGorDocStart(checkObj))

                }
                // this.allDocIdsInTask =[...docIds, data._id]
                else {
                    this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, this.documentData));
                }
            }
        })
        this.existingDocumentClicked = true;
    }
    remove(document) {
        // if ((this.userId === document.attachedBy._id) && (this.isCreator || !isApproverEndoser || taskDetail.canModify)) {
        const dialogRef = this.dialog.open(NotificationModalComponent, {
            width: '450px',
            panelClass: 'cmp-modal',
            data: {
                text: "Are you sure you want to remove this document?"
            },
            hasBackdrop: true
        })
        dialogRef.afterClosed().subscribe((response) => {
            console.log(response);
            if (response !== undefined && response) {
                this.store.dispatch(new DeleteDocumentInTaskStartAction(this.taskDetail._id, document._id || document.id))
            }
        })
        // }
        // else {Check
        //     this.dialog.open(NotificationModalComponent, {
        //         width: '450px',
        //         hasBackdrop: true,
        //         panelClass: 'cmp-modal',
        //         data: {
        //             text: "Sorry you do not have access to remove this document",
        //             button: 'ok'
        //         }
        //     })
        // }


    }
    onDocClick(document) {

        if ((this.userId === document.attachedBy._id)) {
            let a = this.route.navigate([`../home/resources/doc/${document._id || document.id}`])

        }
        else {
            this.api.getUserCapabilitiesForDocument(document._id || document.id).pipe(take(1), catchError((err) => {

                this.dialog.open(NotificationModalComponent, {
                    width: '450px',
                    hasBackdrop: true,
                    panelClass: 'cmp-modal',
                    data: {
                        text: "You don't have access to view this document",
                        button: 'ok'
                    }
                })
                return of(new ErrorAction(err))
            }
            )).subscribe((data: any) => {
                if (data && data.length) {
                    this.route.navigate([`../home/resources/doc/${document._id || document.id}`])
                }
            },
            )
        }
    }

    submitComment(comment) {
        this.commentPostPayload["entity_id"] = this.taskId;
        this.commentPostPayload["comment"] = comment;

        this.store.dispatch(new postComment(this.commentPostPayload));
        this.store
            .select(state => state.resources.comment)
            .subscribe(
                res => {
                    if (Object.keys(this.ngxPermissionService.getPermissions()).includes('view-activity-log')) {
                        this.store.dispatch(new GetActivityLog(this.taskId));
                    }
                    this.store.dispatch(new getComments(this.taskId, 'task'));
                    this.store.select(state => state.resources.comments)
                        .subscribe(
                            response => {
                                this.comments = response["comments"];
                                this.commentText = '';
                                this.comments.map(comment => {
                                    comment.displayPic = `${environment.host}/user/getImage/${comment.user._id}`
                                })
                            },
                            error => {
                                console.log(error);
                            }
                        );
                },
                err => { }
            );
    }

    tabChange(event) { }

    canAbleToEditTask(userId) {
        console.log(this.taskDetail);
        const approverIds = (this.taskDetail.approvers || []).map(({ _id }) => _id);
        const endorserIds = (this.taskDetail.endorsers || []).map(({ _id }) => _id);
        const creatorId = [(this.taskDetail.owner || {})._id];
        const ownerId = [(this.taskDetail.actualAssignee || {})._id];
        const viewerIds = (this.taskDetail.viewers || []).map(({ _id }) => _id);
        const taskUsers = [...approverIds, ...endorserIds, ...creatorId, ...ownerId, ...viewerIds];
        console.log(taskUsers);
        console.log(this.userId);
        console.log(taskUsers.includes(userId));
        return taskUsers.includes(userId);
    }

    setDefaultPic(item) {
        if (typeof item == "string" && item == 'myDefaultPic') {
            this.profilePic = "assets/images/user_profile.svg";
        }
        else {
            item.displayPic = "assets/images/user_profile.svg"
        }
    }

    approveTag(tag, user) {
        this.payload = { tagIdToAdd: tag, userId: user }
        this.store.dispatch(new ApproveTaskTags(this.taskId, this.payload))
        this.payload['tagIdToAdd'] = ''
    }

    rejectTag(tag, user) {
        this.payload = { tagIdToAdd: tag, userId: user }
        this.store.dispatch(new RejectTaskTags(this.taskId, this.payload))
        this.payload['tagIdToAdd'] = ''
    }

    approveRemovalTag(tag, user) {
        this.payload = { tagIdToRemove: tag, userId: user }
        this.store.dispatch(new ApproveTaskTags(this.taskId, this.payload))
        this.payload['tagIdToAdd'] = ''
    }

    rejectRemovalTag(tag, user) {
        this.payload = { tagIdToRemove: tag, userId: user }
        this.store.dispatch(new RejectTaskTags(this.taskId, this.payload))
        this.payload['tagIdToAdd'] = ''
    }

    EditTaskDueDate(flag, param) {
        this.EditDueDate = flag
        this.dueDateInput = param
    }

    SaveDueDate(date) {
        date = new Date(date);
        // let dateParam
        // if (date && date.toString().length > 0) {
        //     dateParam = date.getFullYear() + '-' + date.getMonth() + 1 + '-' + date.getDate() + 'T00:00:00.000Z'
        // }
        this.store.dispatch(new EditDueDate({ dueDate: date.getTime() }, this.taskId));
        this.EditDueDate = true;
    }

    SaveStartDate(date) {
        this.store.dispatch(new EditDueDate({ startDate: date.getTime() }, this.taskId));
    }

    refreshComments() {
        this.store.dispatch(new getComments(this.taskId, 'task'));
    }

    saveDescription(description) {
        this.editDescription = !this.editDescription
        let payload = { description: description }
        this.store.dispatch(new UpdateTaskDetails(this.taskDetail._id, payload));
    }
    editClicked() {
        this.editDescription = true;
    }


    keyPressAlphanumeric(event) {

        var inp = String.fromCharCode(event.keyCode);
    
        if (/[a-zA-Z0-9 ]/.test(inp)) {
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }


}   
